import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IAuthState, IUser, UserRole } from "../types/auth.types";

const getInitialCmState = (): IAuthState => {
    const token = localStorage.getItem("cm_token");
    const role = localStorage.getItem("cm_role") as UserRole | null;
    const userStr = localStorage.getItem("cm_user");
    let user: IUser | null = null;

    if (userStr) {
        try {
            user = JSON.parse(userStr);
        } catch (e) {
            console.error("Failed to parse cm user from localStorage", e);
        }
    }

    return {
        token,
        role,
        user,
        loading: false,
        error: null,
    };
};

const initialState: IAuthState = getInitialCmState();

const cmAuthSlice = createSlice({
    name: "cmAuth",
    initialState,
    reducers: {
        cmLoginSuccess: (
            state,
            action: PayloadAction<{
                token: string;
                role: UserRole;
                user: IUser;
            }>
        ) => {
            state.token = action.payload.token;
            state.role = action.payload.role;
            state.user = action.payload.user;
            state.error = null;

            localStorage.setItem("cm_token", action.payload.token);
            localStorage.setItem("cm_role", action.payload.role);
            localStorage.setItem("cm_user", JSON.stringify(action.payload.user));
        },

        cmLogout: (state) => {
            state.token = null;
            state.role = null;
            state.user = null;
            state.error = null;

            localStorage.removeItem("cm_token");
            localStorage.removeItem("cm_role");
            localStorage.removeItem("cm_user");
        },

        clearCmError: (state) => {
            state.error = null;
        },
    },
});

export const { cmLoginSuccess, cmLogout, clearCmError } = cmAuthSlice.actions;
export default cmAuthSlice.reducer;
